import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [{ path: 'process-logout', component: LogoutComponent }];

@NgModule({
    imports: [CommonModule, RouterModule.forChild(routes), LogoutComponent],
})
export class AuthModule {}
